import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { ChangeEvent } from 'react';
import useForm from 'hooks/useForm';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import { defaultReportLabel, reportOptions } from '../constants';
import { Option, Select, TextArea, Button, SModalReport } from './styled';

interface ModalReportProps {
  onReport: (val: any) => void;
  onCancel: () => void;
  [key: string]: any;
}

function ModalReport({ onReport, onCancel, ...props }: ModalReportProps) {
  const [type, setType] = useForm({ initialState: defaultReportLabel });
  const [message, setMessage] = useForm({ initialState: '' });

  const handleSubmitReport = () => {
    if (message) {
      const data = {
        type,
        message,
      };

      // send back form data to parent
      onReport(data);
    } else {
      handleErrorMessageAPI(
        'Report reason cannot be empty',
        'alert-red',
        false,
      );
    }
  };

  const onChangeType = (e: string | ChangeEvent<HTMLSelectElement>) => {
    setType(e);
  };

  return (
    <SModalReport
      onCancel={onCancel}
      {...props}
      title={
        <Text size="16px" height="40px" family="bold">
          Report Stream
        </Text>
      }
      centered
      width={280}
      footer={[
        <Button key="cancel" block height="40px" onClick={onCancel}>
          <Text align="center">Cancel</Text>
        </Button>,
        <Button
          key="confirm"
          block
          type="primary"
          height="40px"
          onClick={handleSubmitReport}
        >
          <Text align="center" color={color.light}>
            Submit
          </Text>
        </Button>,
      ]}
    >
      <Text size="12px">Report type : </Text>
      <Select value={type} onChange={onChangeType}>
        {reportOptions.map(({ label, key }) => (
          // @ts-expect-error
          <Option key={key} value={label}>
            {label}
          </Option>
        ))}
      </Select>
      {/* @ts-expect-error */}
      <Text size="12px" mt="5px">
        Why is this message inappropriate?
      </Text>
      {/* @ts-expect-error */}
      <TextArea value={message} onChange={setMessage} rows={8} />
    </SModalReport>
  );
}

export default ModalReport;
